import classNames from 'classnames';
import { useCallback } from 'react';
import { Button, ButtonProps } from 'yoso';
import {
  LikeBrandResponse,
  useBrandLike,
  useProceedAgreeMp,
  useProceedLikeBrand,
} from '~/components/Dosi/Brand/Like/BrandLike.hooks';
import { Heart } from '~/components/Icon';
import styles from './BrandLikeButton.module.scss';
export type BrandLikeButtonProps = ButtonProps;
export const BrandLikeButton = ({
  className,
  children,
  onClick,
  ...props
}: BrandLikeButtonProps) => {
  const {
    data: { likePressed },
    refetch,
  } = useBrandLike({ useErrorBoundary: false });
  const { mutateAsync: proceedAgreeMp } = useProceedAgreeMp();

  const onSuccess = useCallback(
    async ({ likePressed }: LikeBrandResponse) => {
      if (likePressed) {
        await proceedAgreeMp();
      }
    },
    [proceedAgreeMp]
  );

  const onSettled = useCallback(() => {
    refetch();
  }, [refetch]);
  const { mutateAsync: proceedBrandLike } = useProceedLikeBrand({ onSuccess, onSettled });

  const handleButtonClick = useCallback(
    async (e) => {
      onClick?.(e);
      await proceedBrandLike();
    },
    [proceedBrandLike, onClick]
  );

  return (
    <Button
      className={classNames(styles.root, className)}
      onClick={handleButtonClick}
      data-event="click"
      data-event-target={likePressed ? 'citizen_brand_cancel_like' : 'citizen_brand_like'}
      {...props}>
      {children || <Heart active={likePressed} />}
    </Button>
  );
};
